import gql from "graphql-tag"

const fragment = gql`
  fragment sagaSnapshotDeal on Deal {
    bannerImage
    contactInfo
    header
    importantInfo
    isValidFor24Hours
    redemptionInstructions
    typeHighlight
    savings {
      userSavings {
        header
        type
        value
      }
    }
    thumbnailImage
    type
    uuid
  }
`

export const toString = fragment.loc.source.body

export default fragment
